import { UsersThree } from "@phosphor-icons/react";

import Progress from "common/components/ui/Progress";
import { Tag } from "common/components/ui/Tag";

interface AudienceProgressProps {
  progress: number;
}

export default function AudienceProgress({ progress }: AudienceProgressProps) {
  return (
    <article className="z-11 rounded-3xl bg-white max-lg:mb-4 lg:absolute lg:bottom-28 lg:right-6 lg:w-96 lg:border lg:border-purple-500 lg:p-3 lg:shadow-lg">
      <div className="mb-2 flex items-center text-black-700">
        <UsersThree weight="fill" size={16} />
        <span className="mx-1.5 text-button-xs">Targets</span>
        <Tag variant="secondary">{progress}%</Tag>
      </div>
      <Progress value={progress} className="w-full" />
    </article>
  );
}
